import Base from './base'

export default {
  get () {
    return Base
      .get('/years')
      .then(res => res.data)
      .then(data => data.sort((first, second) => {
        return second.year - first.year
      }))
  }
}
